/** What a switcher entry leads into: a master account's board or an organization. */
export const SwitchTargetKind = {
  MASTER_ACCOUNT: 'MASTER_ACCOUNT',
  ACCOUNT: 'ACCOUNT'
} as const;

export type SwitchTargetKind = (typeof SwitchTargetKind)[keyof typeof SwitchTargetKind];
